import { render, staticRenderFns } from "./OndeEstou.vue?vue&type=template&id=f737c8aa&"
import script from "./OndeEstou.vue?vue&type=script&lang=ts&"
export * from "./OndeEstou.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports